<template>
  <a-row class="status" :gutter="24">
    <a-col class="mb24" :xs="24" :lg="6">
      <div class="status-item">
        <div class="data">
          <div class="data-base">
            <h6 class="ellipsis">
              <a-tooltip placement="bottomLeft" :title="$t('dashboard.fourth.title1')">
                {{ $t('dashboard.fourth.title1') }}
              </a-tooltip>
            </h6>
            <i18n path="dashboard.fourth.nums" tag="p">
              <strong place="n">{{ agent.count }}</strong>
            </i18n>
            <!--            <p>
              <strong v-text="agent.count"></strong>
              <span>个</span>
            </p>-->
          </div>
          <div class="data-icon">
            <b-icon type="iconjiqiren"></b-icon>
          </div>
        </div>
        <p class="other">
          <span class="normal-color">{{ $tc('dashboard.fourth.normal', agent.succ) }}</span>
          <span class="fault-color">{{ $tc('dashboard.fourth.fault', agent.fault) }}</span>
          <!--<span class="using-color">2个启用</span>
          <span class="timeout-color">2个启用</span>
          <span class="error-color">2个启用</span>-->
        </p>
      </div>
    </a-col>
    <a-col class="mb24" :xs="24" :lg="6">
      <div class="status-item">
        <div class="data">
          <div class="data-base">
            <h6 class="ellipsis">
              <a-tooltip placement="bottomLeft" :title="$t('dashboard.fourth.title2')">
                {{ $t('dashboard.fourth.title2') }}
              </a-tooltip>
            </h6>
            <i18n path="dashboard.fourth.nums" tag="p">
              <strong place="n">{{ process.proCount }}</strong>
            </i18n>
          </div>
          <div class="data-icon">
            <b-icon type="iconliucheng"></b-icon>
          </div>
        </div>
        <p class="other">
          <span class="using-color">{{ $tc('dashboard.fourth.using', process.enable) }}</span>
        </p>
      </div>
    </a-col>
    <a-col class="mb24" :xs="24" :lg="6">
      <div class="status-item">
        <div class="data">
          <div class="data-base">
            <h6 class="ellipsis">
              <a-tooltip placement="bottomLeft" :title="$t('dashboard.fourth.title3')">
                {{ $t('dashboard.fourth.title3') }}
              </a-tooltip>
            </h6>
            <i18n path="dashboard.fourth.nums" tag="p">
              <strong place="n">{{ JobComplete.count }}</strong>
            </i18n>
          </div>
          <div class="data-icon">
            <b-icon type="iconwanchengrenwu"></b-icon>
          </div>
        </div>
        <p class="other">
          <span class="normal-color">{{ $tc('dashboard.fourth.normal', JobComplete.jobSucc) }}</span>
          <span class="fault-color">{{ $tc('dashboard.fourth.fault', JobComplete.jobfailed) }}</span>
        </p>
      </div>
    </a-col>
    <a-col class="mb24" :xs="24" :lg="6">
      <div class="status-item">
        <div class="data">
          <div class="data-base">
            <h6 class="ellipsis">
              <a-tooltip placement="bottomLeft" :title="$t('dashboard.fourth.title4')">
                {{ $t('dashboard.fourth.title4') }}
              </a-tooltip>
            </h6>
            <i18n path="dashboard.fourth.nums" tag="p">
              <strong place="n">{{ Jobfailed.count }}</strong>
            </i18n>
          </div>
          <div class="data-icon">
            <b-icon type="iconrenwushibai"></b-icon>
          </div>
        </div>
        <p class="other">
          <span class="timeout-color">{{ $tc('dashboard.fourth.stopped', Jobfailed.jobTimeout) }}</span>
          <span class="error-color">{{ $tc('dashboard.fourth.fault', Jobfailed.jobfailed) }}</span>
        </p>
      </div>
    </a-col>
  </a-row>
</template>

<script>
import { getRobAndTaskInfo } from '@api/dashboard'
export default {
  name: 'Line2',
  data () {
    return {
      agent: {},
      process: {},
      JobComplete: {},
      Jobfailed: {}
    }
  },
  created () {
    this.getRobAndTaskInfo()
  },
  methods: {
    getRobAndTaskInfo () {
      getRobAndTaskInfo()
        .then((result) => {
          if (result) {
            Object.assign(this, result)
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
.status{
  .status-item{
    padding: 0 24px;
    background-color: #fff;
    box-shadow: 2px 2px 6px 1px rgba(239, 241, 245, 0.64);
    .data{
      padding: 34px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .data-base{
        flex: 1;
        overflow: hidden;
        h6{
          font-size: 14px;
          color: #666666;
          font-weight: normal;
        }
        p{
          font-size: 14px;
          color: #999;
          margin-top: 20px;
          line-height: 33px;
          strong{
            font-size: 42px;
            color: #4977fb;
            font-weight: normal;
            margin-right: 8px;
            line-height: 33px;
          }
        }
      }
      .data-icon{
        background-color: #eeeeee;
        width: 68px;
        height: 68px;
        line-height: 68px;
        text-align: center;
        border-radius: 50%;
        color: #4977fc;
        .iconfont{
          font-size: 28px;
        }
      }
    }
    .other{
      border-top: 1px solid #edeef2;
      line-height: 32px;
      span{
        font-size: 12px;
        & + span{
          &::before{
            content: '';
            display: inline;
            border-left: 1px solid #eee;
            margin: 0 8px;
          }
        }
        &.normal-color{
          color: #666666;
        }
        &.fault-color{
          color: #f5222d;
        }
        &.using-color{
          color: #21a61d;
        }
        &.timeout-color{
          color: #ff6b3d;
        }
        &.error-color{
          color: #ff8831;
        }
      }
    }
  }
}
</style>
